<template>
    <div>
        <a-popconfirm ok-text="Edit"
					  cancel-text="Cancel"
                      @confirm="onSubmit"
                      @cancel="handleCancel"
        > 
            <template slot="title">
                <a-card :bordered="false">
                    <a-row :gutter="[24]">
                        <a-form-model ref="groupOptionsForm"
                        >
                            <a-col :span="24">
					            <a-form-model-item class="mb-10" :label="groupOptionsModel.description" :colon="false"
                                                   ref="description"
                                                   prop="description"
                                >
			
					            </a-form-model-item>
				            </a-col>
                        
                            <a-col :span="24">
                                <a-table :columns="cols"
                                         :data-source="groupOptionsModel.options"
                                         rowKey="index"
                                         bordered
                                         size="small"
                                >
                                    <template slot="index" slot-scope="text, record, index">
                                        <p>{{ index + 1 }}</p>
                                    </template>

                                </a-table>
				            </a-col>
                        </a-form-model>
                    </a-row>
                </a-card>
			</template>
            <a-icon slot="icon" type="plus" style="color: red" />
			<a-tag style="background: #fff; borderStyle: dashed;">
      			 {{ description }}
    		</a-tag>
        </a-popconfirm>
    </div>
</template>

<script>

import { mapState } from 'vuex'

const cols = [
    {
		title: '#',
		dataIndex: 'index',
        key: 'index',
        scopedSlots: { customRender: 'index' },
	},
    {
        title : 'description',
        dataIndex: 'description',
        key : 'description',
        scopedSlots: { customRender: 'description' },
    },
    {
        title : 'short name',
        dataIndex: 'shortName',
        key : 'shortName',
        scopedSlots: { customRender: 'shortName' },
    },
    {
        title : 'price',
        dataIndex: 'price',
        key : 'price',
        scopedSlots: { customRender: 'price' },
    },
  
];

export default {

    inject : ['eventBus'],
    props : {
		index : {
			type : Number
		},
        codeName : {
            type : String
        },
		description : {
			type: String
		},
		options : {
			type : Array
		}
	},
	
    computed : {
        ...mapState({
            currency : state => state.localization.currency
        })
    },

    data () {
        return {
            cols,
            groupOptionsModel : {
                codeName : '',
                description : '',
                options : []
            },
        }
    },

    methods : {
        onSubmit() { 
            this.$emit('groupOptionEditEvent', this.groupOptionsModel);                       
        },
        handleCancel() {

        },
        
    },

    created () {
        this.groupOptionsModel.description = this.description;
        this.groupOptionsModel.options = this.options;
    }

}
</script>

<style>
    .editable-row-operations a {
        margin-right: 8px;
    }
</style>